import { createActions } from "redux-actions";

/**
 * The constants here need to match the related actions. The actions
 * themselves are CONSTANT_CASED, but the related constants are camelCased
 * based on the _, so CONSTANT_CASED becomes constantCased, and something
 * like SOME_DUMB_THING is someDumbThing. Kinda dumb, but w/e.
 */
export const {
    questionAnswer,
    questionCurrentSet,
    questionInsert,
    questionNext,
    questionSetAnswer,
    questionSetFilter,
    questionUndo,
    questionsReset,
} = createActions(
    "QUESTION_ANSWER",
    "QUESTION_CURRENT_SET",
    "QUESTION_INSERT",
    "QUESTION_NEXT",
    "QUESTION_SET_ANSWER",
    "QUESTION_SET_FILTER",
    "QUESTION_UNDO",
    "QUESTIONS_RESET",
);
